import React, { FC } from 'react';
import cls from 'classnames';
import { RailProps } from './Rail.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';

import NavChip from '../primitives/navChip/NavChip';
import ButtonIcon from '../../button/buttonIcon/ButtonIcon';
import { StashLogo } from '@stashinvest/react-assets';

export const classNames = getClassNames('sds-rail', [
	'rail-item',
	'nav-stack',
	'stash-logo',
]);

const Rail: FC<RailProps> = (props) => {
	const { className, navItems, selectedIndex, onIndexSelect, onLogoClick } = props;

	return (
		<nav
			className={cls(getRootClassListFromProps(classNames, props), className)}
			data-testid={props['data-testid']}
		>
			<div className={classNames.navStack}>
				<ButtonIcon
					className={cls('size-logo',classNames.stashLogo)}
					Icon={() => {
						return <StashLogo className={classNames.stashLogo} fill="text-brandFill" />;
					}}
					isEnabled
					onClick={onLogoClick}
					size="standard"
				/>

				{navItems.map((itemProps, i) => {
					return (
						<NavChip
							key={`nav-chip-${i}`}
							{...itemProps}
							isSelected={selectedIndex === i}
							onClick={() => {
								onIndexSelect(i);
								if (itemProps.onClick) itemProps.onClick();
							}}
						/>
					);
				})}
			</div>
		</nav>
	);
};

Rail.displayName = 'Rail';

export default Rail;
